const updateAreasStr = {
  toastrSuccess: 'Departamento atualizado',
  toastrSuccess2: ' foi atualizada com sucesso',
  toastrError: 'Departamento já cadastrado',
  toastrError1: 'Insira outro nome'
};

export default updateAreasStr;
